import { compareVersions } from 'compare-versions';

export const isVersionOutdated = (v1?: string, v2?: string): boolean => {
  if (!v1 || !v2) {
    return false;
  }
  try {
    return compareVersions(v1, v2) < 0;
  } catch {
    return false;
  }
};
